module.exports = __webpack_public_path__ + "assets/6ffe9335534ba8284e05a0d49b5725be.png";